import DashboardOverviewScreen from '@v2/pages/dashboard/modules/overview/DashboardOverviewScreen';
import DashboardShowAllScreen from '@v2/pages/dashboard/modules/showAll/DashboardShowAllScreen';
import DashboardDrilldownMachineScreen from '@v2/pages/dashboard/modules/drilldown/DashboardDrilldownMachineScreen';
import DashboardDrilldownCustomerScreen from '@v2/pages/dashboard/modules/drilldown/DashboardDrilldownCustomerScreen';
import DashboardDrilldownPartScreen from '@v2/pages/dashboard/modules/drilldown/DashboardDrilldownPartScreen';
import DashboardDrilldownNcFileScreen from '@v2/pages/dashboard/modules/drilldown/DashboardDrilldownNcFileScreen';

export const DashboardScreenName = 'Dashboard';

export const DashboardOverviewScreenName = 'DashboardOverview';
export const DashboardShowAllScreenName = 'DashboardShowAll';
export const DashboardDrilldownMachineScreenName = 'DashboardDrilldownMachine';
export const DashboardDrilldownCustomerScreenName = 'DashboardDrilldownCustomer';
export const DashboardDrilldownPartScreenName = 'DashboardDrilldownPart';
export const DashboardDrilldownNcFileScreenName = 'DashboardDrilldownNcFile';

export const dashboardLinking = {
  path: 'dashboard',
  screens: {
    [DashboardOverviewScreenName]: '',
    [DashboardShowAllScreenName]: 'show-all',
    [DashboardDrilldownMachineScreenName]: 'drilldown/machine/:drilldownId',
    [DashboardDrilldownCustomerScreenName]: 'drilldown/customer/:drilldownId',
    [DashboardDrilldownPartScreenName]: 'drilldown/part/:drilldownId',
    [DashboardDrilldownNcFileScreenName]: 'nc-file/:ncFileId',
  },
};

export const dashboardConfig = [
  { name: DashboardOverviewScreenName, Component: DashboardOverviewScreen },
  { name: DashboardShowAllScreenName, Component: DashboardShowAllScreen },
  { name: DashboardDrilldownMachineScreenName, Component: DashboardDrilldownMachineScreen },
  { name: DashboardDrilldownCustomerScreenName, Component: DashboardDrilldownCustomerScreen },
  { name: DashboardDrilldownPartScreenName, Component: DashboardDrilldownPartScreen },
  { name: DashboardDrilldownNcFileScreenName, Component: DashboardDrilldownNcFileScreen },
];
